import React from 'react';
import './CoachingBestPractices.styl';

const cultureLink = 'https://www.execvision.io/resource/building-a-coaching-culture/';

export const CoachingBestPracticesContent = () => {
  return (
    <div className="best-practices-content">
      <h4>Measure, Calibrate, Celebrate</h4>
      <p>
        To realize the full ROI of a coaching culture, leadership needs to regularly evaluate
        metrics such as:
      </p>
      <ul>
        <li>New hire ramp time</li>
        <li>Lift in productivity of 'B' players</li>
        <li>Conversation Rates</li>
        <li>Rep attrition</li>
      </ul>
      <p>
        It's also important to regularly calibrate your team. Make sure managers and their teams are
        using a shared vocabulary for coaching and training. Ask managers to score the same call to
        see if they still agree on what 'good' looks like. Maintaining alignment is a key part of a
        coaching culture.
      </p>
      <p>
        Want to learn more best practices?
        <a href={cultureLink} className="generic-link" target="_blank" rel="noreferrer">
          Get the Revenue Leader's Guide to Building a Coaching Culture {'>>'}
        </a>
      </p>
    </div>
  );
};

export default class CoachingBestPractices extends React.PureComponent {
  render() {
    return (
      <div className="coaching-best-practices">
        <div className="header">
          <h3>Coaching Best Practices</h3>
        </div>
        <CoachingBestPracticesContent />
      </div>
    );
  }
}
